/**
 * tdesign v1.10.7
 * (c) 2024 tdesign
 * @license MIT
 */

var prefix = "t";
var config = {
  prefix: prefix
};

export { config as default, prefix };
//# sourceMappingURL=config.js.map
